module.exports = __webpack_public_path__ + "static/img/mk83p.29bbfc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/mk83p.jpg
// module id = T6cA
// module chunks = 0